
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahirehireforcorporateinpune() {



    const cardData =
    {
        keyword: 'Urbania Hire for Corporate in Pune  ',
        heading: 'Amruta Travels: Urbania Hire for Corporate in Pune  ',
        headingDescription: 'Amruta Travels offers Urbania Hire for Corporate in Pune, providing a premium and reliable transportation solution for office outings, client meetings, conferences, team-building trips, and corporate events. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a comfortable and professional journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes corporate Urbania hire in Pune seamless, safe, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Urbania bus hire for corporate in Pune",
      "description": "Urbania bus hire in Pune for corporate travel, office staff transport, meetings, conferences, and company outings with AC comfort."
    },
    {
      "name": "Force Urbania corporate bus hire Pune",
      "description": "Force Urbania corporate bus hire in Pune for luxury group transport, VIP office visits, and business travel with experienced drivers."
    },
    {
      "name": "Urbania bus rental for corporate Pune",
      "description": "Urbania bus rental in Pune for corporate clients, company events, office transfers, and outstation business trips."
    },
    {
      "name": "Corporate Urbania bus service Pune",
      "description": "Corporate Urbania bus service in Pune offering reliable, comfortable, and punctual AC buses for staff and client transportation."
    },
    {
      "name": "Urbania bus on rent for corporate Pune",
      "description": "Urbania bus on rent in Pune for corporate travels, office outings, and business meetings with luxury seating."
    },
    {
      "name": "Urbania bus hire Pune for corporate travels",
      "description": "Urbania bus hire in Pune for corporate trips, client visits, and team outings with professional drivers and AC comfort."
    },
    {
      "name": "Urbania bus rental Pune for office events",
      "description": "Urbania bus rental in Pune for office events, seminars, conferences, and corporate gatherings with spacious seating."
    },
    {
      "name": "Urbania bus for corporate meetings Pune",
      "description": "Urbania bus for corporate meetings in Pune offering timely pick-ups, luxury interiors, and comfortable travel."
    },
    {
      "name": "Urbania bus hire Pune for company outing",
      "description": "Urbania bus hire in Pune for company outings, team building events, and corporate excursions with AC interiors."
    },
    {
      "name": "Urbania bus for business travels Pune",
      "description": "Urbania bus for business travels in Pune for intercity trips, corporate visits, and VIP transport with professional service."
    },
    {
      "name": "13 seater Urbania bus hire for corporate Pune",
      "description": "13 seater Urbania bus hire for corporate use in Pune for small team travel, client visits, and airport transfers."
    },
    {
      "name": "17 seater Urbania bus rental for corporate Pune",
      "description": "17 seater Urbania bus rental for corporate use in Pune for larger teams, office events, and executive travel."
    },
    {
      "name": "Luxury Urbania bus hire Pune corporate",
      "description": "Luxury Urbania bus hire for corporate clients in Pune with plush seating, AC comfort, and premium interiors."
    },
    {
      "name": "AC Urbania bus corporate hire Pune",
      "description": "AC Urbania bus for corporate hire in Pune ensuring comfortable, cool, and smooth travel for business trips."
    },
    {
      "name": "Force Urbania 17 seater corporate bus Pune",
      "description": "Force Urbania 17 seater corporate bus in Pune for group business travel, office staff transport, and VIP executive tours."
    },
    {
      "name": "Urbania corporate bus hire Hinjewadi Pune",
      "description": "Urbania corporate bus hire in Hinjewadi Pune for IT companies, office staff movement, and corporate events."
    },
    {
      "name": "Urbania bus hire for IT companies Pune",
      "description": "Urbania bus hire in Pune specifically for IT companies, providing reliable staff transport and airport transfers."
    },
    {
      "name": "Urbania corporate bus rental Baner Pune",
      "description": "Urbania corporate bus rental in Baner Pune for company outings, client visits, and staff transport with AC comfort."
    },
    {
      "name": "Urbania bus hire Viman Nagar corporate",
      "description": "Urbania bus hire in Viman Nagar Pune for corporate teams, office events, and executive transport."
    },
    {
      "name": "Urbania corporate bus service Pimpri Chinchwad",
      "description": "Urbania corporate bus service in Pimpri Chinchwad for industrial companies, corporate staff transport, and business travel."
    },
    {
      "name": "Urbania corporate bus hire Pune price",
      "description": "Urbania corporate bus hire price in Pune with transparent, affordable rates for offices, businesses, and corporate groups."
    },
    {
      "name": "Urbania bus corporate rent per km Pune",
      "description": "Urbania corporate bus rental in Pune available on per km basis for local, outstation, and airport trips."
    },
    {
      "name": "Affordable Urbania corporate bus Pune",
      "description": "Affordable Urbania corporate bus in Pune providing AC comfort and premium service at budget-friendly rates."
    },
    {
      "name": "Best Urbania corporate bus rental Pune",
      "description": "Best Urbania corporate bus rental in Pune offering well-maintained vehicles, professional drivers, and punctual service."
    },
    {
      "name": "Cheap Urbania corporate bus hire Pune",
      "description": "Cheap Urbania corporate bus hire in Pune for economical business travel without compromising comfort or safety."
    },
    {
      "name": "Book Urbania corporate bus Pune",
      "description": "Book Urbania corporate bus in Pune with easy online booking, flexible schedules, and reliable service."
    },
    {
      "name": "Online Urbania corporate bus booking Pune",
      "description": "Online Urbania corporate bus booking in Pune for hassle-free reservations and premium corporate bus service."
    },
    {
      "name": "Urbania corporate bus service Pune contact",
      "description": "Contact Urbania corporate bus service in Pune for bookings, inquiries, and corporate travel assistance."
    },
    {
      "name": "13 Seater Urbania Bus Hire for Corporate in Pune",
      "description": "13 Seater Urbania Bus Hire in Pune for small corporate teams, executive travel, and airport pickups."
    },
    {
      "name": "Luxury Force Urbania Corporate Bus Rental Pune",
      "description": "Luxury Force Urbania corporate bus rental in Pune with plush interiors, AC comfort, and professional chauffeur service."
    }
  ],
  "tableData": [
    ["Urbania bus hire for corporate in Pune", "Force Urbania corporate bus hire Pune"],
    ["Urbania bus rental for corporate Pune", "Corporate Urbania bus service Pune"],
    ["Urbania bus on rent for corporate Pune", "Urbania bus hire Pune for corporate travels"],
    ["Urbania bus rental Pune for office events", "Urbania bus for corporate meetings Pune"],
    ["Urbania bus hire Pune for company outing", "Urbania bus for business travels Pune"],
    ["13 seater Urbania bus hire for corporate Pune", "17 seater Urbania bus rental for corporate Pune"],
    ["Luxury Urbania bus hire Pune corporate", "AC Urbania bus corporate hire Pune"],
    ["Force Urbania 17 seater corporate bus Pune", "Urbania corporate bus hire Hinjewadi Pune"],
    ["Urbania bus hire for IT companies Pune", "Urbania corporate bus rental Baner Pune"],
    ["Urbania bus hire Viman Nagar corporate", "Urbania corporate bus service Pimpri Chinchwad"],
    ["Urbania corporate bus hire Pune price", "Urbania bus corporate rent per km Pune"],
    ["Affordable Urbania corporate bus Pune", "Best Urbania corporate bus rental Pune"],
    ["Cheap Urbania corporate bus hire Pune", "Book Urbania corporate bus Pune"],
    ["Online Urbania corporate bus booking Pune", "Urbania corporate bus service Pune contact"],
    ["13 Seater Urbania Bus Hire for Corporate in Pune", "Luxury Force Urbania Corporate Bus Rental Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Professional Urbania Hire for Corporate in Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire for Corporate in Pune, providing a stylish, comfortable, and reliable solution for corporate travel, client meetings, team outings, and business events."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events and Business Travel",
    "WhyChoosedescription": "Whether it’s transporting employees, clients, or VIP guests, our Urbania rentals ensure spacious seating, comfort, and punctual service for all corporate requirements in Pune."
  },
  {
    "WhyChooseheading": "Comfortable and Luxurious Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, and ample luggage space, making them perfect for corporate travel, airport transfers, and city commutes."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "All Urbania hires for corporate travel come with trained and professional drivers who prioritize safety, timeliness, and a smooth, pleasant journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for corporate Urbania hires in Pune, providing excellent value for your company without any hidden charges."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced, cleaned, and sanitized to ensure the highest standards of comfort, hygiene, and safety for corporate travel."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We offer customized pickup and drop-off locations and routes for corporate travel in Pune, making it easy to plan meetings, events, and office transfers efficiently."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania for corporate use in Pune is simple with Amruta Travels. Our support team assists you at every step for a seamless and professional experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania for corporate travel in Pune?',
    answer: 'You can book an Urbania for corporate travel in Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate events and meetings?',
    answer: 'Yes, Urbania is ideal for corporate events, offering spacious seating, comfort, and professional service for employees, clients, and VIP guests.'
  },
  {
    question: 'Can I customize routes for corporate travel in Pune?',
    answer: 'Absolutely! We provide flexible and customized routes for corporate Urbania hires to suit your business schedule and locations.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and experienced driver who ensures a smooth, safe, and timely corporate travel experience.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Yes, all our Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain high standards of comfort, hygiene, and safety.'
  },
  {
    question: 'What is the cost of Urbania hire for corporate use in Pune?',
    answer: 'The rental cost depends on distance, duration, and type of corporate travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I arrange multiple pickups and drop-offs for corporate travel?',
    answer: 'Yes, we offer flexible pickup and drop-off options for corporate travel, making it convenient to transport teams and clients across Pune.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire for corporate use in Pune?',
    answer: 'Amruta Travels provides well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support to ensure a premium and hassle-free corporate travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Deshpande',
    role: 'Corporate Manager, Pune',
    text: 'We hired an Urbania for corporate client visits in Pune. The vehicle was spacious, comfortable, and the driver was punctual and professional. Amruta Travels made our corporate travel smooth and reliable!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Mehta',
    role: 'HR Executive, Pune',
    text: 'Booked an Urbania for our company’s team outing. The ride was comfortable, on time, and hassle-free. Highly recommend Amruta Travels for corporate Urbania rentals!',
    rating: 5
  }
];





























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/urbania-corporate-pune.jpg",
      "url": "https://bushireinpune.com/urbania-corporate-pune",
      "telephone": "+91 7353109555",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Pune",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "areaServed": [
        { "@type": "Place", "name": "Hinjewadi" },
        { "@type": "Place", "name": "Magarpatta" },
        { "@type": "Place", "name": "Kharadi" },
        { "@type": "Place", "name": "Baner" }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "8420"
      }
    },
    {
      "@type": "Service",
      "serviceType": "Urbania Corporate Bus Hire Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description": "Corporate Urbania rental in Pune for IT companies, staff transport, business travel and office outings."
    },
    {
      "@type": "Product",
      "name": "Urbania Corporate Bus Hire in Pune",
      "image": "https://bushireinpune.com/assets/images/urbania-corporate-pune.jpg",
      "description": "Hire 13 and 17 seater Force Urbania vans in Pune for corporate travel, employee transport and office events with AC and professional drivers.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "8420"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "6000",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/urbania-corporate-pune"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide Urbania for corporate travel in Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we provide Urbania for IT companies, office staff transport, business meetings and corporate events in Pune."
          }
        },
        {
          "@type": "Question",
          "name": "Which areas do you cover for corporate travel?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve Hinjewadi, Magarpatta, Kharadi, Baner and all major IT hubs in Pune."
          }
        },
        {
          "@type": "Question",
          "name": "What seating options are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Urbania vans are available in 13 seater and 17 seater options for corporate use."
          }
        }
      ]
    }
  ]
};



    return (
        <div>


<Helmet>
  <title>
    Urbania Corporate Bus Hire in Pune | Staff Transport & IT Travel | Call 7353109555
  </title>

  <meta
    name="description"
    content="Book Urbania corporate bus hire in Pune for IT companies, staff transport, office events & business trips. 13 & 17 seater Force Urbania vans with AC & professional drivers."
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/122.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahirehireforcorporateinpune;